/**
 * 공급사 화면의 «마감» 판정.
 *
 * 공급사(외부) API 는 `status` 를 진행 축(IN_PROGRESS / CONTRACT_IN_PROGRESS)으로만 주고, 마감
 * 여부는 `isClosed`(마감일 경과 또는 발주기관 수동 마감)로 **따로** 준다(백엔드
 * `isExternalQuoteRequestClosed`). 화면이 `status` 만 보면 마감일이 지난 공고도 전부 «진행중» +
 * [참여하기] 로 보였다(V-10·A3-09).
 *
 * `isClosed` 가 없는 응답(옛 경로·미리보기 샘플)은 서버와 같은 규칙(수동 마감 또는 마감일 경과)으로
 * 계산한다.
 */
export interface ClosableQuoteRequest {
  status?: string | null;
  deadline?: string | null;
  isClosed?: boolean | null;
}

export function isQuoteRequestClosed(
  request: ClosableQuoteRequest,
  now: Date = new Date(),
): boolean {
  if (typeof request.isClosed === "boolean") return request.isClosed;
  if (request.status === "CLOSED") return true;
  if (!request.deadline) return false;
  const deadlineTime = Date.parse(request.deadline);
  return Number.isFinite(deadlineTime) && deadlineTime < now.getTime();
}

/** 카드·뱃지에 쓸 상태 — 마감이면 CLOSED, 아니면 진행중. */
export function displayStatusOf<T extends ClosableQuoteRequest>(
  request: T,
  now: Date = new Date(),
): "CLOSED" | "IN_PROGRESS" {
  return isQuoteRequestClosed(request, now) ? "CLOSED" : "IN_PROGRESS";
}

export const QUOTE_REQUEST_CLOSED_MESSAGE =
  "마감된 견적 요청이라 더 이상 견적을 낼 수 없습니다.";
